import { supabase } from '@/lib/supabase'
import type { Tables } from '@/types/database.types'

export type Invitation = Tables<'invitations'>
export type InvitationRole = 'companion' | 'viewer'

export async function inviteTripMember(
  tripId: string,
  email: string,
  role: InvitationRole,
): Promise<void> {
  const { error } = await supabase.rpc('invite_trip_member', {
    p_trip_id: tripId,
    p_email: email,
    p_role: role,
  })
  if (error) throw error
}

export async function listPendingInvitations(tripId: string): Promise<Invitation[]> {
  const { data, error } = await supabase
    .from('invitations')
    .select('*')
    .eq('trip_id', tripId)
    .eq('status', 'pending')
    .order('created_at')
  if (error) throw error
  return data
}

export async function revokeInvitation(invitationId: string): Promise<void> {
  const { error } = await supabase.from('invitations').delete().eq('id', invitationId)
  if (error) throw error
}
